import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.xdos.uk';

export type EventRuntimeResponse = {
  eventId: string;
  name: string;
  title?: string;
  gameType: string;
  phase?: 'pre' | 'during' | 'post';
  gamePeriod: number;
  maxGamePeriods: number;
  inPlay: boolean;
  periodStatus?: 'ready' | 'running' | 'ended';
  labels?: {
    currentPeriodName: string;
    nextPeriodName: string;
    startActionLabel: string;
    endActionLabel: string;
    gameOverLabel: string;
    continuous?: boolean;
  };
  score?: {
    left: number;
    right: number;
  };
  timer: {
    startedAt: number | null;
    accumulatedMs: number;
    running: boolean;
  };
  permissions: {
    canControlTimer: boolean;
    canViewTimer: boolean;
  };
  log: {
    ts: number;
    action: string;
    actorUserId?: string;
    actorRole?: string | null;
    note?: string;
  }[];
};

export async function getEventRuntime(eventId: string): Promise<EventRuntimeResponse> {
  const data = await axios.get<any, EventRuntimeResponse>(`${API_URL}/events/${eventId}/runtime`);
  return data;
}

export async function startEvent(eventId: string): Promise<EventRuntimeResponse> {
  const data = await axios.post<any, EventRuntimeResponse>(`${API_URL}/events/${eventId}/start`, {});
  return data;
}

export async function endEvent(eventId: string): Promise<EventRuntimeResponse> {
  const data = await axios.post<any, EventRuntimeResponse>(`${API_URL}/events/${eventId}/end`, {});
  return data;
}

export async function adjustScore(
  eventId: string,
  side: 'left' | 'right',
  delta: number,
): Promise<EventRuntimeResponse> {
  const data = await axios.post<any, EventRuntimeResponse>(`${API_URL}/events/${eventId}/score`, {
    side,
    delta,
  });
  return data;
}

export async function resetGame(eventId: string): Promise<EventRuntimeResponse> {
  const data = await axios.post<any, EventRuntimeResponse>(`${API_URL}/events/${eventId}/reset`, {});
  return data;
}

export async function undoScore(eventId: string): Promise<EventRuntimeResponse> {
  const data = await axios.post<any, EventRuntimeResponse>(`${API_URL}/events/${eventId}/score/undo`, {});
  return data;
}